export default "__VITE_ASSET__CCzib7Uy__"